const parseCompModules = (data: any) => data.map((item: any) => item.name);

export default parseCompModules;



// WEBPACK FOOTER //
// ./src/services/api/comp-modules/utils/parseCompModules.ts